import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Elektrizitaetsverbrauch extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;
    gemeinde_id: number | null = null;
    verbrauch: number | null = null;
    energieversorgungsunternehmen: string | null = null;
    ort: string | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;
    gemeinde: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Elektrizitaetsverbrauch';
    }
}

export async function createNewElektrizitaetsverbrauch(): Promise<Elektrizitaetsverbrauch> {
    const elektrizitaetsverbrauch = createModel(Elektrizitaetsverbrauch, {});

    await elektrizitaetsverbrauch.save();
    return elektrizitaetsverbrauch;
}

export class ElektrizitaetsverbrauchCollection extends BaseCollection<Elektrizitaetsverbrauch> {
    protected modelCls = Elektrizitaetsverbrauch;

    public getModelClassName(): string {
        return 'Elektrizitaetsverbrauch';
    }
}
